import type { ReactNode, JSX } from 'react';
import { type VariantProps, tv } from 'tailwind-variants';

import type { CommonProps } from '../../types';
import { ButtonOrLink } from '../button-or-link';

export interface YourekaButtonProps
    extends CommonProps,
        VariantProps<typeof YourekaButtonStyles> {
    children?: ReactNode;
    href: string;
}

export const YourekaButtonStyles = tv({
    slots: {
        root: 'bg-black/70 text-white px-6 py-3 md:py-5 md:px-10 font-medium rounded-full hover:scale-105 focus-button focus:scale-105 transition',
        buttonText: 'block text-lg md:text-3xl whitespace-nowrap',
        poweredBy: 'whitespace-nowrap block text-xs',
        brand: 'sr-only',
        brandWrapper: 'flex items-center gap-1 justify-center',
    },
    variants: {},
});

export const YourekaButton = ({
    className,
    children,
    href,
    testId = 'youreka-button',
    ...props
}: YourekaButtonProps): JSX.Element => {
    const { root, buttonText, poweredBy, brand, brandWrapper } =
        YourekaButtonStyles();
    return (
        <ButtonOrLink
            className={root({ className })}
            href={href}
            testId={testId}
            {...props}
        >
            <span className={buttonText()}>{children}</span>
            <div className={brandWrapper()}>
                <span className={poweredBy()}>
                    powered by
                    <em className={brand()}>Youreka</em>
                </span>
                <img
                    alt=""
                    aria-hidden={true}
                    src="/assets/youreka-logo.svg"
                    width="80"
                />
            </div>
        </ButtonOrLink>
    );
};
